module.exports = __webpack_public_path__ + "img/mark.ac66ae99.svg";